import Api from '@/services/Api'

export default {
 getProviders () {
   return Api().get("/providers");
},
  updateProvider (params) {
    return Api().put("/providers",params);
  },
  addProvider (params) {
    return Api().post("/providers",params);
  },
  getProvider (params) {
    return Api().get("/providers/"+params);
  },
  deleteProvider (params) {
    return Api().delete("/providers/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/ProviderService.js